export default {"src":"/_next/static/media/check_green.a0ba4556.svg","height":192,"width":192,"blurWidth":0,"blurHeight":0};